import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AuthHeader } from 'components';
import Join from 'components/Auth/Join';
import { useGoogleLogin } from 'hooks/useGoogleLogin';
import Utils from 'lib/Utils';
import routeConstants from 'routes/routeConstants';
import { clearSignUpUser } from 'store/SignUp';
import SignUpTerms from './components/Terms';

const SignUpOptions: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { googleAuthInit, googleUnavailable } = useGoogleLogin({
    redirectUri: Utils.buildUrl(routeConstants.public.redirectGoogle.signUp),
  });

  const authHeader = <AuthHeader data-cy="join-header" title="Join Kickfin" subtitle="Create an account to start collecting tips." />;

  const onEmailSignUpClick = () => {
    history.push(routeConstants.public.signUpEmail);
  };

  // Clear the signup form from being persisted by sessionStorage.
  // We persist this data to allow the user to go back in the process without
  // needing to retype all the information.
  dispatch(clearSignUpUser());

  return <Join loginLink={routeConstants.public.login} onEmailSignUpClick={onEmailSignUpClick} handleGoogleLogin={googleAuthInit} isGoogleUnavailable={googleUnavailable} authHeader={authHeader} authTerms={<SignUpTerms />} />;
};

export default SignUpOptions;
